
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('back-to-top') && (binding.modules['back-to-top'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-back-to-top' */
            'partner/modules/back-to-top/back-to-top.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'back-to-top',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/back-to-top'
    });
        

    isNotRegistered('checkout-invoice') && (binding.modules['checkout-invoice'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-invoice' */
            'partner/modules/checkout-invoice/checkout-invoice.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'modules/checkout-invoice/actions/get-country-regions', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-invoice',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-invoice'
    });
        

    isNotRegistered('checkout-payment-instrument-v002') && (binding.modules['checkout-payment-instrument-v002'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-payment-instrument-v002' */
            'partner/modules/checkout-payment-instrument-v002/checkout-payment-instrument-v002.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/checkout-payment-instrument-v002/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-payment-instrument-v002',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-payment-instrument-v002'
    });
        

    isNotRegistered('commision-junction') && (binding.modules['commision-junction'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-commision-junction' */
            'partner/modules/commision-junction/commision-junction.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'commision-junction',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/commision-junction'
    });
        

    isNotRegistered('country-selector') && (binding.modules['country-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-country-selector' */
            'partner/modules/country-selector/country-selector.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'country-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/country-selector'
    });
        

    isNotRegistered('custom-checkout-apple-pay') && (binding.modules['custom-checkout-apple-pay'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-apple-pay' */
            'partner/modules/custom-checkout-apple-pay/custom-checkout-apple-pay.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-apple-pay/actions/get-card-payment-accept-point', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-checkout-apple-pay',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-checkout-apple-pay'
    });
        

    isNotRegistered('custom-checkout-google-pay') && (binding.modules['custom-checkout-google-pay'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-google-pay' */
            'partner/modules/custom-checkout-google-pay/custom-checkout-google-pay.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-checkout-google-pay',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-checkout-google-pay'
    });
        

    isNotRegistered('custom-checkout-shipping-address') && (binding.modules['custom-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-shipping-address' */
            'partner/modules/custom-checkout-shipping-address/custom-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-checkout-shipping-address'
    });
        

    isNotRegistered('custom-code') && (binding.modules['custom-code'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-code' */
            'partner/modules/custom-code/custom-code.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-code',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-code'
    });
        

    isNotRegistered('custom-contentcode-block') && (binding.modules['custom-contentcode-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-contentcode-block' */
            'partner/modules/custom-contentcode-block/custom-contentcode-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-contentcode-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-contentcode-block'
    });
        

    isNotRegistered('custom-image-banner') && (binding.modules['custom-image-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-image-banner' */
            'partner/modules/custom-image-banner/custom-image-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-image-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-image-banner'
    });
        

    isNotRegistered('custom-product-page-summary') && (binding.modules['custom-product-page-summary'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-product-page-summary' */
            'partner/modules/custom-product-page-summary/custom-product-page-summary.tsx'),
        $type: 'scriptModule',
        da: [{name:'productAvailabilities',  path:'modules/custom-product-page-summary/actions/getEstimatedAvailability.action', runOn: 0},{name:'productPageSummary',  path:'modules/custom-product-page-summary/custom-product-page-summary.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-product-page-summary',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-product-page-summary'
    });
        

    isNotRegistered('email-verification') && (binding.modules['email-verification'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-email-verification' */
            'partner/modules/email-verification/email-verification.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'email-verification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/email-verification'
    });
        

    isNotRegistered('filtered-delivery-options') && (binding.modules['filtered-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-filtered-delivery-options' */
            'partner/modules/filtered-delivery-options/filtered-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'filtered-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/filtered-delivery-options'
    });
        

    isNotRegistered('find-store-worldwide') && (binding.modules['find-store-worldwide'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-find-store-worldwide' */
            'partner/modules/find-store-worldwide/find-store-worldwide.tsx'),
        $type: 'containerModule',
        da: [{name:'availabilitiesWithHours',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby', runOn: 1},{name:'storeLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'find-store-worldwide',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/find-store-worldwide'
    });
        

    isNotRegistered('fm-account-profile') && (binding.modules['fm-account-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fm-account-profile' */
            'partner/modules/fm-account-profile/fm-account-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'profileConsents',  path:'actions/get-profile-consents.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'fm-account-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/fm-account-profile'
    });
        

    isNotRegistered('footer-navigation-menu') && (binding.modules['footer-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-footer-navigation-menu' */
            'partner/modules/footer-navigation-menu/footer-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'footer-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/footer-navigation-menu'
    });
        

    isNotRegistered('generic-popup') && (binding.modules['generic-popup'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-generic-popup' */
            'partner/modules/generic-popup/generic-popup.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'generic-popup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/generic-popup'
    });
        

    isNotRegistered('gift-card-personalization') && (binding.modules['gift-card-personalization'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gift-card-personalization' */
            'partner/modules/gift-card-personalization/gift-card-personalization.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'gift-card-personalization',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gift-card-personalization'
    });
        

    isNotRegistered('gift-with-purchase') && (binding.modules['gift-with-purchase'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gift-with-purchase' */
            'partner/modules/gift-with-purchase/gift-with-purchase.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'gift-with-purchase',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gift-with-purchase'
    });
        

    isNotRegistered('hero-banner') && (binding.modules['hero-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hero-banner' */
            'partner/modules/hero-banner/hero-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hero-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hero-banner'
    });
        

    isNotRegistered('hero-banner-slide') && (binding.modules['hero-banner-slide'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hero-banner-slide' */
            'partner/modules/hero-banner-slide/hero-banner-slide.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hero-banner-slide',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hero-banner-slide'
    });
        

    isNotRegistered('linked-container') && (binding.modules['linked-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-linked-container' */
            'partner/modules/linked-container/linked-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'linked-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/linked-container'
    });
        

    isNotRegistered('loyalty-balance-check') && (binding.modules['loyalty-balance-check'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-balance-check' */
            'partner/modules/loyalty-balance-check/loyalty-balance-check.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'loyalty-balance-check',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/loyalty-balance-check'
    });
        

    isNotRegistered('loyalty-store-sign-up') && (binding.modules['loyalty-store-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-store-sign-up' */
            'partner/modules/loyalty-store-sign-up/loyalty-store-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'loyalty-store-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/loyalty-store-sign-up'
    });
        

    isNotRegistered('map-custom') && (binding.modules['map-custom'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-map-custom' */
            'partner/modules/map-custom/map-custom.tsx'),
        $type: 'contentModule',
        da: [{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'map-custom',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/map-custom'
    });
        

    isNotRegistered('new-checkout-delivery-options') && (binding.modules['new-checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-checkout-delivery-options' */
            'partner/modules/new-checkout-delivery-options/new-checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'cartConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'products',  path:'modules/new-checkout-delivery-options/actions/get-products-details-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'new-checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/new-checkout-delivery-options'
    });
        

    isNotRegistered('new-checkout-shipping-address') && (binding.modules['new-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-checkout-shipping-address' */
            'partner/modules/new-checkout-shipping-address/new-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'modules/new-checkout-shipping-address/actions/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'modules/new-checkout-shipping-address/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'modules/new-checkout-shipping-address/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'new-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/new-checkout-shipping-address'
    });
        

    isNotRegistered('new-sign-up') && (binding.modules['new-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-sign-up' */
            'partner/modules/new-sign-up/new-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'new-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/new-sign-up'
    });
        

    isNotRegistered('newsletter-block') && (binding.modules['newsletter-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-newsletter-block' */
            'partner/modules/newsletter-block/newsletter-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'newsletter-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/newsletter-block'
    });
        

    isNotRegistered('plp-subheader') && (binding.modules['plp-subheader'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-plp-subheader' */
            'partner/modules/plp-subheader/plp-subheader.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'plp-subheader',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/plp-subheader'
    });
        

    isNotRegistered('pva-chat-connector') && (binding.modules['pva-chat-connector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-pva-chat-connector' */
            'partner/modules/pva-chat-connector/pva-chat-connector.tsx'),
        $type: 'contentModule',
        da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'getBotFrameworkToken',  path:'modules/pva-chat-connector/actions/getBotFrameworkToken.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'pva-chat-connector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/pva-chat-connector'
    });
        

    isNotRegistered('region-selector') && (binding.modules['region-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-region-selector' */
            'partner/modules/region-selector/region-selector.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'region-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/region-selector'
    });
        

    isNotRegistered('region-tile-selector') && (binding.modules['region-tile-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-region-tile-selector' */
            'partner/modules/region-tile-selector/region-tile-selector.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'region-tile-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/region-tile-selector'
    });
        

    isNotRegistered('timeline') && (binding.modules['timeline'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-timeline' */
            'partner/modules/timeline/timeline.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'timeline',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/timeline'
    });
        

    isNotRegistered('unsubscribe-newsletter') && (binding.modules['unsubscribe-newsletter'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-unsubscribe-newsletter' */
            'partner/modules/unsubscribe-newsletter/unsubscribe-newsletter.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'unsubscribe-newsletter',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/unsubscribe-newsletter'
    });
        

    isNotRegistered('venchi-v2') && (binding.modules['venchi-v2'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-venchi-v2' */
            'partner/themes/venchi-v2/venchi-v2.tsx'),
        $type: 'themeModule',
        da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'loyalty-terms',runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 0}],
        definitionExtensions: ['account-generic-tile','account-loyalty-tile','account-loyalty','account-management-address','account-profile','breadcrumb','buybox','cart-icon','cart','checkout-delivery-options','checkout-section-container','checkout','content-block','header','loyalty-sign-up','loyalty-terms','map','navigation-menu','order-confirmation','order-details','product-collection','product-specification','promo-banner','reviews-list','search-result-container','search','sign-in','sign-up','store-selector','text-block','video-player'],
        iNM: false,
        ns: '__local__',
        n: 'venchi-v2',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'venchi-v2.theme.settings.json',
        md: 'src/themes/venchi-v2'
    });
        

    isNotRegistered('venchi-v2-1') && (binding.modules['venchi-v2-1'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-venchi-v2-1' */
            'partner/themes/venchi-v2-1/venchi-v2-1.tsx'),
        $type: 'themeModule',
        da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'loyalty-terms',runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 0}],
        definitionExtensions: ['account-generic-tile','account-loyalty-tile','account-loyalty','account-management-address','account-profile','breadcrumb','buybox','cart-icon','cart','checkout-delivery-options','checkout-section-container','checkout','content-block','country-selector','header','loyalty-sign-up','loyalty-terms','map','navigation-menu','order-confirmation','order-details','product-collection','product-specification','promo-banner','reviews-list','search-result-container','search','sign-in','sign-up','store-selector','text-block','video-player'],
        iNM: false,
        ns: '__local__',
        n: 'venchi-v2-1',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'venchi-v2-1.theme.settings.json',
        md: 'src/themes/venchi-v2-1'
    });
        

    isNotRegistered('webform') && (binding.modules['webform'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-webform' */
            'partner/modules/webform/webform.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'webform',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/webform'
    });
        

        {   
            const actionPath = 'actions/custom-get-store-location-information.action';
            binding.dataActions[actionPath] = require('partner/actions/custom-get-store-location-information.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-cart-state-update-loylaty.action';
            binding.dataActions[actionPath] = require('partner/actions/get-cart-state-update-loylaty.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-profile-consents.action';
            binding.dataActions[actionPath] = require('partner/actions/get-profile-consents.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/actions/product-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/custom-product-page-summary/actions/getEstimatedAvailability.action';
            binding.dataActions[actionPath] = require('partner/modules/custom-product-page-summary/actions/getEstimatedAvailability.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/custom-product-page-summary/custom-product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/custom-product-page-summary/custom-product-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/pva-chat-connector/actions/getBotFrameworkToken.action';
            binding.dataActions[actionPath] = require('partner/modules/pva-chat-connector/actions/getBotFrameworkToken.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('checkout-invoice')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-invoice')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-invoice')){
            const sanitizedActionPath = 'modules/checkout-invoice/actions/get-country-regions';
            let dataAction = require('partner/modules/checkout-invoice/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument-v002')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument-v002')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument-v002')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument-v002')){
            const sanitizedActionPath = 'modules/checkout-payment-instrument-v002/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/checkout-payment-instrument-v002/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('country-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-apple-pay')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-apple-pay/actions/get-card-payment-accept-point';
            let dataAction = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-apple-pay/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-apple-pay')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-google-pay')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-product-page-summary')){
            const sanitizedActionPath = 'modules/custom-product-page-summary/actions/getEstimatedAvailability.action';
            let dataAction = require('partner/modules/custom-product-page-summary/actions/getEstimatedAvailability.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('custom-product-page-summary')){
            const sanitizedActionPath = 'modules/custom-product-page-summary/custom-product-page-summary.action';
            let dataAction = require('partner/modules/custom-product-page-summary/custom-product-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('filtered-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('filtered-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('filtered-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('filtered-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('find-store-worldwide')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('find-store-worldwide')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('find-store-worldwide')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fm-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fm-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fm-account-profile')){
            const sanitizedActionPath = 'actions/get-profile-consents.action';
            let dataAction = require('partner/actions/get-profile-consents.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('footer-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gift-card-personalization')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gift-with-purchase')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('map-custom')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-delivery-options')){
            const sanitizedActionPath = 'modules/new-checkout-delivery-options/actions/get-products-details-in-active-checkout-cart';
            let dataAction = require('partner/modules/new-checkout-delivery-options/actions/get-products-details-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = 'modules/new-checkout-shipping-address/actions/get-address-purposes';
            let dataAction = require('partner/modules/new-checkout-shipping-address/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = 'modules/new-checkout-shipping-address/actions/get-country-regions';
            let dataAction = require('partner/modules/new-checkout-shipping-address/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('new-checkout-shipping-address')){
            const sanitizedActionPath = 'modules/new-checkout-shipping-address/actions/get-country-state';
            let dataAction = require('partner/modules/new-checkout-shipping-address/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('pva-chat-connector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('pva-chat-connector')){
            const sanitizedActionPath = 'modules/pva-chat-connector/actions/getBotFrameworkToken.action';
            let dataAction = require('partner/modules/pva-chat-connector/actions/getBotFrameworkToken.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('venchi-v2')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('venchi-v2')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('venchi-v2-1')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('venchi-v2-1')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};